// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './contexts/AuthContext'; // Importando o hook useAuth

// Telas
import ItensMenu from './pages/ItensMenu';
import ItemDetails from './pages/ItemDetails';
import Cart from './pages/Pedido/Cart';
import Endereco from './pages/Pedido/Endereco';
import Pagamento from './pages/Pedido/Pagamento';
import Resumo from './pages/Pedido/Resumo';
import OrderMenu2 from './pages/OrderMenu2';
import ResumoPedido from './pages/Pedido/ResumoPedido';
import Pedidos from './pages/Pedido/Pedidos';
import TipoPizza from './pages/Pizza/TipoPizza';
import PizzaDetails from './pages/Pizza/PizzaDetails';
import Login from './pages/Login';
import CadastrarUsuario from './pages/Cliente/CadastrarUsuario';
import PerfilUsuario from './pages/Cliente/PerfilUsuario';
import CadastrarEndereco from './pages/Cliente/CadastrarEndereco';
import { useCart } from './contexts/CartContext';
import ResumoPedidoSemLogin from './pages/Pedido/ResumoPedidoSemLogin';
import ListagemProdutos from './pages/ListagemProdutos';
import ListagemProdutosGpt from './pages/ListagemProdutosGpt';
import GerarPix from './pages/Pedido/GerarPix';
import Comanda from './pages/Comanda';
import TelefoneLink from './pages/TelefoneLink';


const App = () => {
  const { isAuthenticated } = useAuth(); // Usando o contexto para verificar autenticação
  const { setCartItemCount, setCartItemTotal } = useCart();

  useEffect(() => {    
      const cart = JSON.parse(localStorage.getItem('cart')) || [];
      const count = cart.reduce((accumulator, item) => accumulator + item.qtde, 0);
      const total = cart.reduce((accumulator, item) => accumulator + item.valorTotal, 0);
      setCartItemTotal(total); 
      setCartItemCount(count);
  }, []);

  return (
    <Router>
      <TelefoneLink />
      <Routes>
        <Route path="/" element={<OrderMenu2 />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastrarusuario" element={<CadastrarUsuario />} />        
        <Route path="/ordermenu" element={<OrderMenu2 />} />
        <Route path="/ordermenu2" element={<OrderMenu2 />} />
        <Route path="/listagemprodutos" element={<ListagemProdutos />} />
        <Route path="/listagemprodutosgpt" element={<ListagemProdutosGpt />} />
        <Route path="/itensmenu/:groupId" element={<ItensMenu />} />
        <Route path="/itemdetails/:id" element={<ItemDetails />} />
        <Route path="/pizzaDetails/:id/:groupId" element={<PizzaDetails />} />
        <Route path="/tipoPizza/:groupId" element={<TipoPizza />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/pagamento" element={<Pagamento />} />        
        <Route path="/resumo" element={<Resumo />} />
        <Route path="/endereco" element={<Endereco />}/>
        <Route path="/resumo-pedido/:pedidoId" element={<ResumoPedido />} />
        <Route path="/pix/:token" element={<GerarPix />} />
        <Route path="/comanda/:chave" element={<Comanda />} />
        {/* Rota para clientes não logados */}
        <Route path="/resumo-pedido-sem-login" element={<ResumoPedidoSemLogin />} />
        <Route path="/resumo-pedido-sem-login/:tokenResumo" element={<ResumoPedidoSemLogin />} />
        

        {/** Proteja as rotas abaixo */}
        {/*
        <Route
          path="/endereco"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<Endereco />} />}
        />
        <Route
          path="/cadastrar-endereco"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<CadastrarEndereco />} />}
        />
        */}
        {/*
        <Route
          path="/pagamento"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<Pagamento />} />}
        />
        <Route
          path="/resumo"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<Resumo />} />}
        />        
        <Route
          path="/resumo-pedido/:pedidoId"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<ResumoPedido />} />}
        />
        */}
        <Route
          path="/perfilusuario"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<PerfilUsuario />} />}
        />
        <Route
          path="/pedidos"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<Pedidos />} />}
        />
        <Route
          path="/endereco"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<Endereco />} />}
        />
        <Route
          path="/cadastrar-endereco"
          element={<ProtectedRoute isAuthenticated={isAuthenticated} element={<CadastrarEndereco />} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
